module.exports = __webpack_public_path__ + "img/portmone.cda77cc5.png";